import React from 'react';
import { Activity } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050505] border-t border-brand-panelBorder py-12" data-id="element-26">
      <div className="max-w-6xl mx-auto px-6 flex flex-col items-center text-center" data-id="element-27">
        <div className="flex items-center gap-2 mb-6 opacity-50" data-id="element-28">
          <Activity className="w-5 h-5 text-brand-green" data-id="element-29" />
          <span className="font-bold tracking-tight" data-id="element-30">THE WEARABLE FIX</span>
        </div>

        <p className="text-xs text-brand-gray max-w-2xl mb-6 leading-relaxed" data-id="element-31">
          Disclaimer: The information provided in this protocol is for
          educational purposes only and is not intended as medical advice.
          Consult with a healthcare professional before making any changes to
          your health routine. Not affiliated with Oura, Whoop, Garmin, or
          Apple.
        </p>

        <div className="flex gap-6 text-xs text-brand-gray/60" data-id="element-32">
          <a href="#" className="hover:text-white transition-colors" data-id="element-33">
            Terms of Service
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-34">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-35">
            Contact
          </a>
        </div>

        <div className="mt-8 text-xs text-brand-gray/40" data-id="element-36">
          © 2026 The Wearable Fix. All rights reserved.
        </div>
      </div>
    </footer>;
}